<template>
  <div class="box">
    <o-table
      :loading="loading"
      :items="stagePaths"
      :show-total="false"
      :draggable="false"
      :checkable="true"
      :checked-rows="selectedPaths"
      @check="
        selectedPaths = $event
        selectedPath = null
      "
    >
      <b-table-column v-slot="{ row }" field="name" label="Nom">
        <template v-if="!showRow(row)">
          {{ row.name }}
        </template>
        <template v-else-if="showRow(row)">
          <b-field>
            <b-input v-model="name" type="text" />
          </b-field>
        </template>
      </b-table-column>
      <b-table-column v-slot="{ row }" field="liveCategoryIds" label="Catégories">
        <template v-if="!showRow(row)">
          <b-tooltip
            v-if="row.liveCategoryIds.length"
            position="is-bottom"
            multilined
            type="is-light"
          >
            {{ row.liveCategoryIds.length }}
            <b-icon icon="circle-info" size="is-small" type="is-info" />
            <template v-slot:content>
              {{ getCategoryNames(row.liveCategoryIds) }}
            </template>
          </b-tooltip>
          <template v-else>—</template>
        </template>
        <template v-else>
          <b-dropdown v-model="liveCategoryIds" multiple aria-role="list" position="is-top-right">
            <template #trigger>
              <b-button icon-right="chevron-down"> {{ liveCategoryIds.length }} </b-button>
            </template>
            <b-dropdown-item aria-role="menu-item" :focusable="false" custom paddingless>
              <b-checkbox-button
                v-for="category in filteredCategories"
                :key="category.id"
                v-model="liveCategoryIds"
                class="px-2 py-1"
                :native-value="category.id"
                :type="`is-${category.color}`"
              >
                {{ category.name }}
              </b-checkbox-button>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table-column>
      <b-table-column v-slot="{ row }" field="points" label="Points" centered>
        {{ row.pathLength }}
      </b-table-column>
      <b-table-column v-slot="{ row }" label="">
        <div v-if="!showRow(row)" class="buttons are-small is-right">
          <b-button type="is-primary" @click="editPath(row)">
            <b-icon icon="edit" />
          </b-button>
          <b-button type="is-danger" @click="toggleModal(row)">
            <b-icon icon="trash" />
          </b-button>
        </div>
        <div v-else-if="showRow(row)" class="buttons are-small is-right">
          <b-button type="is-success" @click="submit">
            <b-icon icon="check" />
          </b-button>
          <b-button type="is-warning" @click="selectedPath = null">
            <b-icon icon="times" />
          </b-button>
        </div>
      </b-table-column>
      <template #empty>
        <div class="has-text-grey has-text-centered">Aucune route complète</div>
      </template>
    </o-table>
    <LiveStagePathForm
      v-if="selectedPaths.length"
      :loading="loading"
      class="column is-full"
      @delete="$emit('deleteAll', selectedPaths)"
    />
    <o-modal
      :title="modalTitle"
      :isOpen="!!selectedPath && isOpenModal"
      @closeModal="toggleModal"
      @confirmModalAction="$emit('delete', selectedPath)"
    >
      <template> La suppression d'une route complète est <strong>définitive</strong>. </template>
    </o-modal>
  </div>
</template>

<script>
import LiveStagePathForm from './LiveStagePathForm.vue'
import OTable from '@components/Table.vue'
import OModal from '@components/Modal.vue'

export default {
  name: 'LiveStagePathTable',

  components: {
    LiveStagePathForm,
    OModal,
    OTable,
  },

  props: {
    loading: {
      type: Boolean,
      required: true,
    },
    stagePaths: {
      type: Array,
      required: true,
    },
    liveCategories: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      name: '',
      selectedPath: null,
      selectedPaths: [],
      liveCategoryIds: [],
      isOpenModal: false,
    }
  },

  watch: {
    stagePaths() {
      this.selectedPath = null
      this.selectedPaths = []
    },
  },

  computed: {
    filteredCategories() {
      const existingCategories = this.stagePaths.map((path) => path.liveCategoryIds).flat()

      return this.liveCategories.filter((category) => {
        if (
          this.selectedPath?.liveCategoryIds.length &&
          this.selectedPath.liveCategoryIds.includes(category.id)
        ) {
          return true
        }

        return !existingCategories.includes(category.id)
      })
    },

    modalTitle() {
      return `Suppression de la route ${this.selectedPath && this.selectedPath.name}`
    },
  },

  methods: {
    showRow(row) {
      return this.selectedPath && !this.isOpenModal && row.id === this.selectedPath.id
    },

    submit() {
      this.$emit('submit', {
        ...this.selectedPath,
        name: this.name,
        liveCategoryIds: this.liveCategoryIds,
      })

      this.selectedPath = null
    },

    editPath(route) {
      this.selectedPath = route
      this.name = route.name
      this.liveCategoryIds = route.liveCategoryIds
    },

    getCategoryNames(categoryIds) {
      const names = []
      for (const categoryId of categoryIds) {
        const category = this.liveCategories.find((c) => c.id === categoryId)
        if (category) {
          names.push(category.name)
        }
      }

      return names.length ? names.join(', ') : '—'
    },

    toggleModal(path = null) {
      this.isOpenModal = !!path
      this.selectedPath = path
    },
  },
}
</script>
